import { useEffect, useState } from "react";
import axios from "axios";
// import Sidebar from "../components/Sidebar";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import "./Logbooks.css";
import { toast } from 'react-toastify';

export default function Logbooks() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]); 

  const [formData, setFormData] = useState({
    log_date: "",
    department_id: "",
    log_book_issued_for: "",
    issued_by: "",
    issued_to: ""
  });

  const token = localStorage.getItem("token");

  const api = axios.create({
    baseURL: `${baseURL}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  // Interceptor to catch expired sessions
  api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      toast.error("Session expired. Redirecting to login...");
      localStorage.removeItem("token");
      window.location.href = "/login"; // login page navigation
    }
    return Promise.reject(error);
  });

  // Fetch logbooks, departments, employees
  useEffect(() => {
    fetchLogs();
    fetchDepartments();
    fetchEmployees(); 
  }, []);

  const fetchLogs = async () => {
    try {
      const response = await api.get("/log_books");
      setLogs(response.data);
    } catch (error) {
      console.error("Error fetching logs:", error);
      alert("Error fetching log books. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await api.get("/departments");
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchEmployees = async () => {
    try {
      const response = await api.get("/employees");
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    if (formData.issued_by === formData.issued_to) {
      alert("Issued by person and Issued to person cannot be the same!");
      return;
    }

    try {
      await api.post("/log_books", formData);
      setShowForm(false);
      setFormData({
        log_date: "",
        department_id: "",
        log_book_issued_for: "",
        issued_by: "",
        issued_to: ""
      });
      fetchLogs();
    } catch (error) {
      console.error("Error adding log:", error);
      alert("Failed to add log book entry. Check console for details.");
    }
  };

  const exportToExcel = () => {
    if (logs.length === 0) {
      alert("No data available to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(logs);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "LogBooks");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "LogBooks.xlsx");
  };

  return (
    <div className="logbooks-layout">
      {/* <Sidebar /> */}

      <div className="logbooks-container">
        <div className="logbooks-header">
          <h2>Log Book</h2>
          <div className="header-actions">
          <button className="export-btn" onClick={exportToExcel}>
              Export to Excel
          </button>
          <button className="add-btn" onClick={() => setShowForm(true)}>
            + Add
          </button>
        </div>
      </div>

        {loading ? (
          <p>Loading logs...</p>
        ) : (
          <table className="logbooks-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Log Date</th>
                <th>Department</th>
                <th>Issued For</th>
                <th>Issued By</th>
                <th>Issued To</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {logs.length > 0 ? (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td>{log.id}</td>
                    <td>{log.log_date}</td>
                    <td>{log.department_name}</td>
                    <td>{log.log_book_issued_for}</td>
                    <td>{log.issued_by_name}</td>
                    <td>{log.issued_to_name}</td>
                    <td>{log.created_at}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        {/* Add Log Entry */}
        {showForm && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Add Log Entry</h3>
              <form onSubmit={handleAdd}>
                <input
                  type="date"
                  name="log_date"
                  value={formData.log_date}
                  onChange={handleChange}
                  required
                />

                {/* Department dropdown */}
                <select
                  name="department_id"
                  value={formData.department_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Department</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.department_name}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  name="log_book_issued_for"
                  placeholder="Issued For"
                  value={formData.log_book_issued_for}
                  onChange={handleChange}
                  required
                />

                {/* Issued By dropdown */}
                <select
                  name="issued_by"
                  value={formData.issued_by}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Issued By</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.comp_name}
                    </option>
                  ))}
                </select>

                {/* Issued To dropdown */}
                <select
                  name="issued_to"
                  value={formData.issued_to}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Issued To</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.comp_name}
                    </option>
                  ))}
                </select>

                <div className="modal-actions">
                  <button type="submit" className="save-btn">Save</button>
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={() => setShowForm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}